import React from "react";
import ReactDOM from "react-dom";
import Home from "./Pages/Home/index";
import "./index.css";
ReactDOM.render(<Home />, document.getElementById("root"));
